<div class="col-lg-12 parent">
  <div class="row child">
    <div class="orders-invoice mb-4" [formGroup]="parent">
      <div class="d-flex align-items-center justify-content-between pb-3">
        <h2 class="m-0">Invoice Emails</h2>
        <div
          class="d-flex justify-content-end pointer gap-2 align-items-center">
          <a
            [hidden]="addAndRemoveButtons"
            class="link-gray"
            (click)="onAddNewLine()">
            <i class="pi pi-plus"></i> Add new</a
          >
          <a
            [hidden]="addAndRemoveButtons || !showRemoveButton"
            class="link-gray delcol"
            (click)="removeLine()">
            <i class="pi pi-trash"></i> Remove</a
          >
        </div>
      </div>
      <div class="indropdowntable">
        <p-table
          #dt
          stripedRows
          [rowHover]="true"
          [rows]="20"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          [size]="'small'"
          [value]="invoiceListing"
          [(selection)]="selectedInvoiceListing"
          styleClass="p-datatable-customers ordersLineItems no-wrap table-hover-bg"
          [rowHover]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="false"
          [filterDelay]="0"
          dataKey="portalKey"
          editMode="row"
          selectionMode="single"
          selectionMode="multiple"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th></th>
              <!-- <th style="text-align: center">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th> -->
              <th class="name">Name</th>
              <th class="purpose">Purpose</th>
              <th class="email">Email</th>
              <th class="save">Save</th>
              <th class="exist">Exist</th>
              <th class="confirmation">Confirmation</th>
              <th class="Invoice">Invoice</th>
            </tr>
            <tr>
              <th></th>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="name"
                    id="name"
                    (input)="
                      dt.filter($any($event.target).value, 'name', 'contains')
                    "
                    placeholder=""
                    class="p-column-filter" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="email"
                    id="email"
                    (input)="
                      dt.filter($any($event.target).value, 'email', 'contains')
                    "
                    placeholder=""
                    class="p-column-filter" />
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-invoicedEmail
            let-editing="editing"
            let-ri="rowIndex">
            <ng-container>
              <tr
                class="p-selectable-row"
                [pSelectableRow]="invoicedEmail"
                [pEditableRow]="invoicedEmail">
                <td style="text-align: center">
                  <button
                    *ngIf="!editing"
                    pButton
                    pRipple
                    type="button"
                    pInitEditableRow
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-text"
                    (click)="onEditRow(invoicedEmail)"></button>
                  <button
                    *ngIf="editing"
                    pButton
                    pRipple
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-check"
                    class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
                  <button
                    *ngIf="editing"
                    pButton
                    pRipple
                    type="button"
                    pCancelEditableRow
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-danger"></button>
                </td>
                <!-- <td class="col-center">
                <p-tableCheckbox [value]="invoicedEmail"></p-tableCheckbox>
              </td> -->
                <td>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <input
                        jniAutoCompleteBlocker
                        pInputText
                        [ngModelOptions]="{ standalone: true }"
                        style="width: 6rem"
                        type="text"
                        [(ngModel)]="invoicedEmail.name"
                        required />
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{ invoicedEmail.name }}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-select
                        class="invoiceemaildropdown"
                        [appendTo]="'body'"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="invoicedEmail.purpose"
                        [options]="type"
                        optionLabel="name"
                        optionValue="name"
                        [filter]="true"
                        [showClear]="true">
                      </p-select>
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{ invoicedEmail.purpose }}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <input
                        jniAutoCompleteBlocker
                        pInputText
                        [ngModelOptions]="{ standalone: true }"
                        style="width: 6rem"
                        type="text"
                        [(ngModel)]="invoicedEmail.email"
                        required />
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{ invoicedEmail.email }}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td>
                  <p-checkbox
                    id="save"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="invoicedEmail.save"
                    inputId="save"
                    [binary]="true"></p-checkbox>
                </td>
                <td>
                  <p-checkbox
                    id="exist"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="invoicedEmail.exist"
                    [disabled]="true"
                    inputId="exist"
                    [binary]="true"></p-checkbox>
                </td>
                <td>
                  <p-checkbox
                    id="confirmation"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="invoicedEmail.confirmation"
                    inputId="confirmation"
                    [binary]="true"></p-checkbox>
                </td>

                <td>
                  <p-checkbox
                    id="invoice"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="invoicedEmail.invoice"
                    inputId="invoice"
                    [binary]="true"></p-checkbox>
                </td>
              </tr>
            </ng-container>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No line item found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="d-flex py-3 justify-content-end gap-3">
      <p-button label="Cancel" (click)="closeModel()" />

      <p-button
        label="Save"
        (click)="saveModel()"
        variant="outlined"
        severity="secondary" />
    </div>
  </div>
</div>
